export const PURCHASE_TYPE = 'purchase'
export const REFINANCE_TYPE = 'refinance'

export const DOWN_PAYMENT_DEFAULT = 60000
export const ESTIMATED_VALUE_DEFAULT = 300000
export const HOME_VALUE_DEFAULT = 300000
export const LOAN_AMOUNT_DEFAULT = 240000

export const ZIP_CODE_DEFAULT = '95814'

export const EXCELLENT_FICO_TYPE = 'excellent'
export const SECOND_HOME_OCCUPANCY_TYPE = 'secondHome'
export const SINGLE_FAMILY_PROPERTY_TYPE = 'singleFamily'

export const APR_SORTING_OPTION = 'apr'

export const MORTGAGE_FILTER_FORM_NAME = 'mortgage-rates'
export const MORTGAGE_SORTING_FORM_NAME = 'mortgage-rates-sorting'

export const ELIGIBILITY_UUID_PURCHASE = 'eligibilityUUIDPurchase'
export const ELIGIBILITY_UUID_REFINANCE = 'eligibilityUUIDRefinance'
export const ELIGIBILITY_LOAN_TYPE = 'loanType'

export const INITIAL_VALUES_BASE_KEYS = ['loanType', 'options', 'sorting', 'zipCode', 'terms']

export const FIFTEEN_YEARS_FIXED = 'fifteenYearsFixed'
export const THIRTY_YEARS_FIXED = 'thirtyYearsFixed'
export const THIRTY_YEARS_FIXED_JUMBO = 'thirtyYearsFixedJumbo'
export const FIFTEEN_YEARS_FIXED_JUMBO = 'fifteenYearsFixedJumbo'
export const FIVE_ONE_ARM = 'fiveOneARM'
export const TWENTY_YEARS_FIXED = 'twentyYearsFixed'
export const TEN_YEARS_FIXED = 'tenYearsFixed'
export const SEVEN_ONE_ARM = 'sevenOneARM'
export const TEN_ONE_ARM = 'tenOneARM'

export const DEFAULT_TERMS_ARR = [THIRTY_YEARS_FIXED, FIFTEEN_YEARS_FIXED]
export const TERMS_LIMIT = 2
export const CASH_OUT_LIMIT_INDEX = 0.8
